/**
 * HTTP Webhook trigger configuration type and validation
 * Note: Webhook URL and secret are auto-generated by the backend
 */

export type HttpWebhookTriggerConfigType = {
  /** Optional JSON Schema for payload autocomplete */
  payloadSchema?: string;
  /** Enable schema-based autocomplete (default: true) */
  useSchemaAutocomplete?: boolean;
};

export const defaultHttpWebhookTriggerConfig: HttpWebhookTriggerConfigType = {
  useSchemaAutocomplete: true,
};

export const validateHttpWebhookTriggerConfig = (
  config: HttpWebhookTriggerConfigType,
): Record<string, string> => {
  const errors: Record<string, string> = {};

  // Validate JSON Schema if provided
  if (config.payloadSchema) {
    try {
      JSON.parse(config.payloadSchema);
    } catch {
      errors.payloadSchema = 'Invalid JSON Schema';
    }
  }

  return errors;
};

/**
 * Get preview text for the node display
 */
export const getHttpWebhookTriggerPreviewText = (
  _config: HttpWebhookTriggerConfigType,
): string => 'Webhook endpoint auto-generated';
